import { render, staticRenderFns } from "./SVGLinkText.vue?vue&type=template&id=35a9cc6d"
import script from "./SVGLinkText.vue?vue&type=script&lang=js"
export * from "./SVGLinkText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports